define(['jquery', 'core/urls'],
    function($, urls) {
        function initializeAndWaitUntilReady(onReady) {
            // load the script from the remote host
            $.getScript(window.uploadcare_widget_src);

            function waitUntilReady() {
                if (window.uploadcare === undefined) {
                    setTimeout(waitUntilReady, 500);
                } else {
                    if (onReady) {
                        onReady(window.uploadcare);
                    }
                }
            }
            setTimeout(waitUntilReady, 1);
        }

        function maxSize(max) {
            return function(fileInfo) {
                if (fileInfo.size === null) {
                    return;
                }
                if (max && fileInfo.size > max) {
                    throw new Error('fileMaximumSize');
                }
            };
        }

        function fileTypeLimit(types) {
            types = types.split(' ');
            return function(fileInfo) {
                if (fileInfo.name === null) {
                    return;
                }
                var extension = fileInfo.name.split('.').pop();
                if (types.indexOf(extension) === -1) {
                    throw new Error("fileType");
                }
            };
        }

        return {
            initializeAndWaitUntilReady: initializeAndWaitUntilReady,
            maxSizeValidator: maxSize,
            fileTypeValidator: fileTypeLimit
        };
    }
);
